import { t } from "ttag";

import { Chip } from "@/shared/ui";
import { useSessionCategory, useSessionStatus } from "../hooks";
import {
  getSessionCategoryLabel,
  SESSION_CATEGORY,
  SESSION_STATUS,
} from "../models";

export const SessionCategories = () => {
  const { status } = useSessionStatus();
  const {
    category,
    actions: { setPaginatedCategory },
  } = useSessionCategory();

  const isPastSession = status === SESSION_STATUS.PAST;

  return (
    <div className="flex flex-wrap items-center justify-center gap-2.5">
      <Chip
        color={category ? "light-secondary" : "dark-secondary"}
        size="large"
        onClick={() => setPaginatedCategory(null)}
      >
        {t`All sessions`}
      </Chip>

      {Object.values(SESSION_CATEGORY).map((sessionCategory) => {
        if (sessionCategory === SESSION_CATEGORY.GROUP && isPastSession) {
          return null;
        }

        return (
          <Chip
            key={sessionCategory}
            color={
              category === sessionCategory
                ? "dark-secondary"
                : "light-secondary"
            }
            size="large"
            onClick={() => setPaginatedCategory(sessionCategory)}
          >
            {getSessionCategoryLabel(sessionCategory)}
          </Chip>
        );
      })}
    </div>
  );
};
